export default __webpack_public_path__ + "static/media/assets.dc35ed51.svg";